export default "__VITE_ASSET__4ZtjpL93sTPU6gkwh4kSdw__"